import { FileX2 } from "lucide-react";
import { StatusBadge } from "@/components/common/StatusBadge";
import { mxn } from "@/lib/format";
import { DocBotones } from "@/components/solicitudes/comite/DocBotones";

const DATOS = [["nombre", "Nombre"], ["tipo_persona", "Tipo de persona"], ["rfc", "RFC"], ["curp", "CURP"],
  ["fecha_nacimiento", "Fecha de nacimiento"], ["fecha_constitucion", "Fecha de constitución"],
  ["nacionalidad", "Nacionalidad"], ["ocupacion", "Ocupación"], ["actividad_economica", "Actividad económica"],
  ["entidad_federativa", "Entidad federativa"]];

export const Seccion = ({ titulo, children, testid }) => (
  <div className="rounded-md border border-slate-100 bg-slate-50 p-2.5" data-testid={testid}>
    <p className="mb-1.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500">{titulo}</p>
    {children}
  </div>
);

export function DatosGenerales({ f }) {
  const filas = DATOS.filter(([k]) => f.datos?.[k]);
  return (
    <Seccion titulo="Datos generales" testid={`comite-ficha-datos-${f.cliente_id}`}>
      <dl className="grid grid-cols-1 gap-x-3 gap-y-1 text-[12px] sm:grid-cols-2">
        {filas.map(([k, l]) => (
          <div key={k}><dt className="text-slate-500">{l}</dt><dd className="font-medium text-slate-800">{f.datos[k]}</dd></div>
        ))}
        <div><dt className="text-slate-500">{f.rol === "solicitante" ? "Monto solicitado" : "Monto solicitado del integrante"}</dt><dd className="font-medium text-slate-800">{mxn(f.monto)}</dd></div>
        <div><dt className="text-slate-500">Tasa</dt><dd className="font-medium text-slate-800">{f.tasa_ordinaria != null ? `${f.tasa_ordinaria}%` : "La del producto"}</dd></div>
      </dl>
    </Seccion>
  );
}

export function Expediente({ f }) {
  const ex = f.expediente || {};
  const enChecklist = new Set((ex.items || []).map((i) => i.doc_id).filter(Boolean));
  const otros = (f.documentos || []).filter((d) => !enChecklist.has(d.id));
  return (
    <Seccion titulo={`Expediente · ${ex.completos ?? 0}/${ex.total ?? 0} vigentes`} testid={`comite-ficha-expediente-${f.cliente_id}`}>
      <div className="mb-1.5"><StatusBadge value={ex.estatus || "—"} /></div>
      <ul className="space-y-1 text-[12px]">
        {(ex.items || []).map((i) => (
          <li key={i.canonical} className="flex flex-wrap items-center gap-2 rounded border border-slate-200 bg-white px-2 py-1"
            data-testid={`comite-ficha-doc-${f.cliente_id}-${i.canonical}`}>
            <span className="text-slate-700">{i.tipo_documento}{i.obligatorio ? <span className="text-red-500">*</span> : null}</span>
            {i.presente && i.con_archivo ? <DocBotones docId={i.doc_id} nombre={i.tipo_documento} testid={`comite-ficha-doc-${f.cliente_id}-${i.canonical}`} />
              : <span className="ml-auto flex items-center gap-1 text-slate-500"><FileX2 className="h-3.5 w-3.5" /> {i.presente ? "Sin archivo" : "No cargado"}</span>}
          </li>
        ))}
        {otros.filter((d) => d.con_archivo).map((d) => (
          <li key={d.id} className="flex flex-wrap items-center gap-2 rounded border border-slate-200 bg-white px-2 py-1"
            data-testid={`comite-ficha-otro-doc-${d.id}`}>
            <span className="text-slate-700">{d.tipo}</span>
            <span className="text-[11px] text-slate-500">{d.fecha || ""}</span>
            <DocBotones docId={d.id} nombre={d.nombre_archivo || d.tipo} testid={`comite-ficha-otro-doc-${d.id}`} />
          </li>
        ))}
      </ul>
    </Seccion>
  );
}
